// uat
 
 
const apiConfig = {
    "baseUrl":"https://synergy-cf-api.axodesk.com:8081",
    // "baseUrl":"http://localhost:8081",
 
 
    "baseUrlMaster":"https://synergy-cf-api.axodesk.com:8082",
    // "baseUrlMaster":"http://localhost:8082",
 
 
 
    "baseUrlDocument":"https://synergy-cf-api.axodesk.com:8083",
    // "baseUrlDocument":"http://localhost:8083",
 
 
 
    "baseUrlIssue":"https://synergy-cf-api.axodesk.com:8084",
    // "baseUrlIssue":"http://localhost:8084",
    // "baseUrlIssue":"http://localhost:8096",
 
   
    "baseUrlBoard":"https://synergy-cf-api.axodesk.com:8085",
    // "baseUrlBoard":"http://localhost:8085",
 
 
 
    "baseUrlMasterWs":"https://synergy-cf-api.axodesk.com:8086",
    // "baseUrlMasterWs":"http://localhost:8086",
 
 
    "baseUrlMasterProject":"https://synergy-cf-api.axodesk.com:8087",
    //  "baseUrlMasterProject":"http://localhost:8087",
 
 
    "baseUrlIdentity": "https://synergy-cf-api.axodesk.com:8088",
    // "baseUrlIdentity": "http://localhost:8081",
 
 
    "baseUrlOthers": "https://synergy-cf-api.axodesk.com:8089",
    // "baseUrlOthers": "http://localhost:8089",
 
 
    "baseUrlSecurity": "https://synergy-cf-api.axodesk.com:8090",
    // "baseUrlSecurity": "http://localhost:8090",
 
 
    "baseUrlReport": "https://synergy-cf-api.axodesk.com:8091",
    // "baseUrlReport": "http://localhost:8091",
 
    "baseUrlCache": "https://synergy-cf-api.axodesk.com:8096",
    // "baseUrlCache":"http://localhost:8096",
   
    "baseUrlAssesments":"https://synergy-cf-api.axodesk.com:8098",
    // "baseUrlAssesments":"http://localhost:8035",
 
    "baseUrlHr":"https://synergy-cf-api.axodesk.com:8099",
    // "baseUrlHr":"http://localhost:3032",
 
    "appName": "Identti Front End",
    "apiKey": "apiKey",
    "secrect": "secrect",
    "appId": "b0dc92bf-3710-4e11-a87d-4d72585cd281",
    "gatWayUrl":"https://79a4z7n2g5.execute-api.ap-south-1.amazonaws.com/dev",
 
 
 
 
 
}
 
export default apiConfig;
 
 
 
 
 
 
 
 
 
 
//  const apiConfig = {
//         "gatWayUrl": "https://identity.tiburaglobal.com:8080",
 
//         // "baseUrl":" https://synergy.axo desk.com:3010",
   
//      //       "baseUrl":"https://api-axodesk.tiburaglobal.com:8081",
   
//     "baseUrl":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlDocument":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlMaster":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlReport": "https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlMasterProject":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlOthers": "https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlIssue":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlMasterWs":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlBoard":"https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlIdentity": "https://api-axodesk.tiburaglobal.com:8081",
//     "baseUrlSecurity": "https://api-axodesk.tiburaglobal.com:8081",
//            //"baseUrl":"http://localhost:3010",
   
//            "appName": "Identti Front End",
   
//            "apiKey": "apiKey",
   
//            "secrect": "secrect"
//     }
//     export default apiConfig;
